import { createElement } from 'react'
import { CalendarCheck, Receipt, Tag, User } from '@phosphor-icons/react'
import { SETTLEMENT_FILTER_KEYS } from '../helpers/indexFilters'

// Identificadores usados para seleccionar y mostrar las pestañas de liquidaciones.
export const SETTLEMENT_INDEX_TAB = {
  SETTLEMENTS: 'settlements',
  DAILY: 'daily'
}

// Rutas independientes del listado y del control diario; cada una tiene su permiso.
export const SETTLEMENT_ROUTES = {
  [SETTLEMENT_INDEX_TAB.SETTLEMENTS]: '/liquidaciones',
  [SETTLEMENT_INDEX_TAB.DAILY]: '/liquidaciones/control-diario'
}

// Configuración que recibe TabsMui: identificador, texto e ícono de cada pestaña.
export const SETTLEMENT_INDEX_TABS = [
  {
    value: SETTLEMENT_INDEX_TAB.SETTLEMENTS,
    label: 'Liquidaciones',
    iconNode: createElement(Receipt, { size: 19 })
  },
  {
    value: SETTLEMENT_INDEX_TAB.DAILY,
    label: 'Control diario',
    iconNode: createElement(CalendarCheck, { size: 19 })
  }
]

// Textos del encabezado, la navegación y la carga del control diario.
export const SETTLEMENT_INDEX_TEXT = {
  TITLE: SETTLEMENT_INDEX_TABS[0].label,
  SUBTITLE: 'Consulta las liquidaciones de cobros, sus montos y estados.',
  TABS_ARIA_LABEL: 'Secciones de liquidaciones',
  DAILY_TITLE: SETTLEMENT_INDEX_TABS[1].label,
  DAILY_LOADING: 'Cargando...'
}

// Textos de filtros, fechas, carga, errores y paginación del listado de liquidaciones.
export const SETTLEMENT_LIST_TEXT = {
  ARIA_LABEL: 'Listado de liquidaciones',
  FILTER_TITLE: 'Filtrar liquidaciones',
  SEARCH_PLACEHOLDER: 'Buscar por código, nombre o # de liquidación...',
  EXPORT_TOOLTIP: 'Descargar página actual en CSV',
  DATE_TITLE: 'Fecha de liquidación',
  DATE_PLACEHOLDER: 'Seleccionar fechas',
  DATE_LABEL: 'Fecha',
  LOADING: 'Cargando...',
  EMPTY: 'No hay liquidaciones para mostrar',
  LOAD_ERROR: 'No se pudieron cargar las liquidaciones.',
  LOAD_RETRY_ERROR: 'No se pudieron cargar las liquidaciones. Intenta nuevamente.',
  PAGINATION_ARIA_LABEL: 'Paginación de liquidaciones',
  PAGINATION_ITEM_LABEL: 'liquidaciones',
  MISSING_VALUE: '—'
}

// Valores iniciales de paginación, cantidad de filtros y claves del listado.
export const SETTLEMENT_LIST_CONFIG = {
  INITIAL_PAGE: 1,
  PER_PAGE: 25,
  PAGINATION_THRESHOLD: 10,
  INLINE_FILTER_COUNT: 2,
  SUPPLEMENTARY_FILTER_COUNT: 1,
  DATE_RANGE_KEY: 'date-range',
  ROW_KEY: 'uuid'
}

// Opciones visuales de los filtros; sus valores se construyen con la respuesta del API.
export const SETTLEMENT_LIST_FILTERS = {
  [SETTLEMENT_FILTER_KEYS.CREATED_BY]: { label: 'Creado por', icon: User },
  [SETTLEMENT_FILTER_KEYS.STATUS]: { label: 'Estado', icon: Tag }
}

// Definición fija de las columnas; el componente agrega cómo se muestra cada celda.
export const SETTLEMENT_LIST_COLUMNS = [
  { key: 'collected_at', label: 'Fecha y hora' },
  { key: 'uid', label: '# de liquidación' },
  { key: 'user_uid', label: SETTLEMENT_LIST_FILTERS[SETTLEMENT_FILTER_KEYS.CREATED_BY].label },
  { key: 'erp_document_reference', label: '# ERP' },
  {
    key: 'total_amount',
    label: 'Total cobrado',
    className: 'text-end',
    headerClassName: 'text-end'
  },
  {
    key: 'status',
    label: SETTLEMENT_LIST_FILTERS[SETTLEMENT_FILTER_KEYS.STATUS].label,
    align: 'center'
  }
]
